const cs = {
    '/': {
        title: '{brand} | Sportovní Sázení, Live Casino & Okamžité Výběry',
        description: 'Automaty, live casino & sportovní sázení u {brand}. Krypto casino s okamžitými výběry, prokazatelně férovými hrami & podporou 24/7.'
    },
    '/casino': {
        title: 'Online Casino | Automaty, Blackjack & Live Dealeři | {brand}',
        description: 'Automaty, blackjack, ruleta & live dealeři u {brand}. Stovky her, rychlé krypto vklady & okamžité výběry dostupné 24/7.'
    },
    '/sports': {
        title: 'Online Sportovní Sázení | Krypto Sázky & Kurzy | {brand}',
        description: 'Sázejte na sport u {brand}. Konkurenční kurzy na fotbal, basketbal & další. Live sázení, bezpečné krypto sázky & rychlé výplaty.'
    },
    '/livecasino': {
        title: 'Live Casino | Blackjack, Ruleta & Live Dealeři | {brand}',
        description: 'Blackjack, ruleta & live casino hry u {brand}. Praví dealeři, HD streaming & široký výběr live stolů dostupných 24/7.'
    },
    '/slots': {
        title: 'Online Automaty | Velký Výběr Casino Slotů | {brand}',
        description: 'Obrovská sbírka automatů u {brand}. Klasické ovocné automaty, video sloty & progresivní jackpoty – vše hratelné s kryptem.'
    },
    '/vip': {
        title: 'VIP Program | Exkluzivní Odměny & Výhody | {brand}',
        description: 'VIP program {brand}: exkluzivní odměny, personalizované bonusy a prioritní podpora. Výhody přizpůsobené věrným hráčům.'
    },
    '/welcome-offer': {
        title: 'Uvítací Bonus | Krypto Casino | {brand}',
        description: 'Získejte uvítací nabídku {brand}. Začněte s kryptem a využijte bonusy pro nové hráče při prvním vkladu.'
    },
    '/referral': {
        title: 'Referral Program | Pozvěte Přátele & Získejte Odměny | {brand}',
        description: 'Pozvěte přátele na {brand} & získejte odměny, když se zaregistrují a začnou hrát. Sdílejte odkaz a sbírejte bonusy za každé doporučení.'
    },
    '/promotion-page': {
        title: 'Casino Akce | Bonusy & Speciální Nabídky | {brand}',
        description: 'Prohlédněte si nejnovější akce {brand}. Aktuální bonusy, turnaje & speciální akce – uplatněte svoji nabídku a začněte hrát.'
    },
    '/featurebuyin': {
        title: 'Feature Buy-In Sloty | Přeskočte na Bonusové Kolo | {brand}',
        description: 'Přeskočte přímo na bonusová kola se sloty s feature buy-in u {brand}. Okamžitě aktivujte bonusové funkce pro šanci na velké výhry.'
    },
    '/gameshows': {
        title: 'Live Game Show | Hrajte Casino Herní Show u {brand}',
        description: 'Hrajte live casino herní show u {brand}. Vychutnejte si Crazy Time, Monopoly Live & další, vedené profesionálními dealery v reálném čase.'
    },
    '/newgames': {
        title: 'Nové Casino Hry | Nejnovější Sloty & Live Hry | {brand}',
        description: 'Hrajte nejnovější casino hry u {brand}. Pravidelně aktualizováno o nové sloty & stolní hry od předních poskytovatelů. Buďte první, kdo hraje.'
    },
    '/populargames': {
        title: 'Populární Casino Hry | Nejlepší Sloty & Live Hry | {brand}',
        description: 'Hrajte nejoblíbenější casino hry u {brand}. Nejlépe hodnocené sloty & stolní hry oblíbené naší komunitou, dostupné s kryptem.'
    },
    '/originals': {
        title: 'Originální Casino Hry | Exkluzivní Tituly | {brand}',
        description: 'Hrajte exkluzivní originální hry u {brand}. Unikátní tituly, které jinde nenajdete, vyvinuté vlastními silami pro nezapomenutelný kasinový zážitek.'
    },
    '/providers': {
        title: 'Herní Poskytovatelé | Partnerská Studia & Software | {brand}',
        description: 'Prozkoumejte všechny herní poskytovatele u {brand}. Spolupracujeme s předními studii, abychom vám přinesli rozmanitou knihovnu krypto kasina vysoké kvality.'
    },
    '/about-us': {
        title: 'O Nás | Zjistěte Více o {brand}',
        description: 'Zjistěte více o {brand}, předním krypto kasinu & sportovní sázkovně. Zavázáni k bezpečnému, férovému & vzrušujícímu hazardu s okamžitými krypto výběry.'
    },
    '/affiliate': {
        title: 'Affiliatní Program | Vydělávejte Krypto s {brand}',
        description: 'Staňte se partnerem {brand} & vydělávejte provize propagací našeho krypto kasina. Konkurenční sazby, sledování v reálném čase & dedikovaná podpora affiliatů.'
    },
    '/faq': {
        title: 'FAQ | Často Kladené Otázky | {brand}',
        description: 'Najděte odpovědi na časté otázky ohledně {brand}. Prohlédněte si naše FAQ pro pomoc s účty, platbami, bonusy & kasino hrami.'
    },
    '/aml-policy': {
        title: 'AML Politika | Boj Proti Praní Peněz v {brand}',
        description: 'AML politika {brand} zajišťuje bezpečné, důvěryhodné prostředí. Přečtěte si o našich opatřeních k předcházení nezákonné činnosti na naší platformě.'
    },
    '/bonus-terms': {
        title: 'Podmínky Bonusů | Akce {brand}',
        description: 'Přečtěte si pravidla bonusů & akcí {brand}. Zjistěte, jak nárokovat, využívat & vybírat bonusové výhry z naší platformy.'
    },
    '/complaints-and-arbitration': {
        title: 'Stížnosti a Arbitráž | Podpora Hráčů v {brand}',
        description: 'Seznamte se s procesem řešení stížností & sporů {brand}. Zaručujeme férové zacházení a řešíme problémy hráčů rychle a transparentně.'
    },
    '/fairness': {
        title: 'Prokazatelně Férové Hry | Záruky Férovosti v {brand}',
        description: '{brand} používá technologii prokazatelné férovosti, aby zaručil, že každý výsledek hry je ověřitelný, transparentní & zcela náhodný.'
    },
    '/fairness-overview': {
        title: 'Přehled Prokazatelně Férového Hraní | {brand}',
        description: 'Systém prokazatelné férovosti {brand} vysvětlen. Kryptografické principy zaručující integritu hry & naprostou náhodnost každého výsledku.'
    },
    '/kyc-policy': {
        title: 'KYC Politika | Znáte Svého Zákazníka v {brand}',
        description: 'KYC politika {brand} popisuje náš proces ověřování totožnosti. Zjistěte, jak chráníme hráče a udržujeme bezpečné herní prostředí.'
    },
    '/payment-policy': {
        title: 'Platební Politika | Krypto Vklady & Výběry | {brand}',
        description: '{brand} přijímá krypto vklady & výběry. Přečtěte si naši platební politiku ohledně limitů transakcí, přijímaných mincí & dob zpracování.'
    },
    '/privacy-policy': {
        title: 'Zásady Ochrany Soukromí | Ochrana Dat v {brand}',
        description: 'Zásady ochrany soukromí {brand}. Zjistěte, jak shromažďujeme, používáme & chráníme vaše osobní údaje na naší krypto kasinové platformě.'
    },
    '/responsible-gaming': {
        title: 'Odpovědné Hraní | Hrajte Bezpečně v {brand}',
        description: '{brand} se zavazuje k odpovědnému hazardu. Přistupujte k nástrojům & zdrojům pro správu svých hráčských návyků a bezpečnou hru.'
    },
    '/terms-of-service': {
        title: 'Podmínky Služby | {brand}',
        description: 'Přečtěte si podmínky & ujednání upravující vaše používání {brand}. Pochopte svá práva a povinnosti jako hráče.'
    },
    '/terms-sports': {
        title: 'Podmínky Sportovního Sázení | {brand}',
        description: 'Podmínky sportovního sázení {brand}. Pravidla pro uzavírání sázek, výplaty výher & používání sportovní sázkové kanceláře na naší platformě.'
    }
};
export default cs;
